import { Skeleton } from 'antd';
import React from 'react';

export function PilotLoadingState() {
  return <Skeleton active />;
}
